import { render, staticRenderFns } from "./ManageUserOrganizationPage.vue?vue&type=template&id=002268dc&scoped=true"
import script from "./ManageUserOrganizationPage.vue?vue&type=script&lang=ts"
export * from "./ManageUserOrganizationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002268dc",
  null
  
)

export default component.exports